export default __webpack_public_path__ + "static/media/defilada.ce716a2f.jpg";